import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from './customBaseQuery';
import { readOnlyAppTagList } from './utils/apiTagTypes';

/**
 * The slice representing the Crop Management System's backend API.
 */
export const cmsApi = createApi({
  reducerPath: 'cmsApi',
  baseQuery: customBaseQuery,
  refetchOnReconnect: true,
  tagTypes: readOnlyAppTagList,
  endpoints: builder => ({
    getAppHealth: builder.query<{ message: string; version: string }, void>({
      query: () => ({
        url: '/health-check',
        method: 'GET',
      }),
      // Always check if the app is healthy.
      forceRefetch: () => true,
    }),
  }),
});

export const { useGetAppHealthQuery } = cmsApi;
